import { createApp } from "vue";
import * as Sentry from "@sentry/vue";
import SocioVueComponents from "@socotec.io/socio-vue-components";
import { openDatabase, readInstalledDatabase } from "@/db";
import { RESYNCED_TABLES, isPendingRecord } from "@/db/pendingRecord";
import i18n from "@/setup/i18n";
import createAtmoVuetify from "@/setup/vuetify";
import DatabaseOpenError from "@/components/atmo/partials/DatabaseOpenError.vue";

const hasPendingChanges = async (installed) => {
  const tables = new Set(installed.tables.map(({ name }) => name));
  const hasRow = async (table, filter) =>
    tables.has(table) &&
    !!(await installed.table(table).filter(filter).first());
  const checks = await Promise.all([
    hasRow("pendingSyncs", Boolean),
    hasRow("garbages", Boolean),
    ...[...RESYNCED_TABLES].map((table) => hasRow(table, isPendingRecord)),
  ]);
  return checks.some(Boolean);
};

export const openDatabaseOrShowError = async () => {
  const error = await openDatabase().then(
    () => null,
    (openError) => openError
  );
  if (!error) return true;

  Sentry.captureException(error);
  createApp(DatabaseOpenError, {
    isNewerVersion: error.name === "VersionError",
    hasPendingChanges: await readInstalledDatabase(hasPendingChanges).catch(
      () => true
    ),
  })
    .use(i18n)
    .use(createAtmoVuetify(i18n))
    .use(SocioVueComponents, i18n)
    .mount("#app");
  return false;
};
